import script from "./LibraryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LibraryPage.vue?vue&type=script&setup=true&lang=js"

import "./LibraryPage.vue?vue&type=style&index=0&id=5d9d7321&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d9d7321"]])

export default __exports__